exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-373a378a&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=1!./src/xman/cause-chart/card.vue
// module id = 279
// module chunks = 0